import styled from 'styled-components';

export const HeadingIconWrapper = styled.div`
    && {
        display: flex;
        align-items: center;
        gap: 4px;
    }
`;

export const StyledLink = styled.a.attrs({
    target: '_blank',
    rel: 'noopener noreferrer',
})`
    outline: none;
    text-decoration: underline;
`;
